import { render, staticRenderFns } from "./TaskApplicability.vue?vue&type=template&id=31a28d72&"
import script from "./TaskApplicability.vue?vue&type=script&lang=js&"
export * from "./TaskApplicability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports